import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IHistoryResponseData, initialHistoryState } from "./historyTypes";
import { getHistoryListThunk } from "./historyThunks";

const initialState: initialHistoryState = {
  history: [],
  currentPage: 1,
  historyCount: 0,
};

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(
      getHistoryListThunk.fulfilled,
      (
        state: initialHistoryState,
        action: PayloadAction<IHistoryResponseData>
      ) => {
        state.history = action.payload.rows;
        state.historyCount = action.payload.count;
      }
    ),
});

export const {} = historySlice.actions;
export const historyReducer = historySlice.reducer;
